import React from 'react';
import { 
  Package, 
  Truck, 
  CheckCircle, 
  ShoppingBag, 
  MapPin, 
  Phone, 
  Mail, 
  XCircle 
} from "lucide-react";

export default function FollowupSection() {
  const getStatusColor = (status) => {
    switch (status) {
      case "processando": return "bg-yellow-500";
      case "enviado": return "bg-blue-500";
      case "entregue": return "bg-green-500";
      default: return "bg-red-500";
    }
  };

  const status = "enviado";
  const statusLabel = "Enviado";

  return (
    <div className="space-y-6 p-4 max-w-6xl mx-auto">
      <div className="flex items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold">Acompanhamento do Pedido</h1>
          <p className="text-gray-500">Pedido #00000 • 00/00/0000</p>
        </div>
        <div className="ml-auto">
          <span className={`px-3 py-1 rounded-full text-white ${getStatusColor(status)}`}>
            {statusLabel}
          </span>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        <div className="md:col-span-2 space-y-6">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="mb-4">
              <h2 className="text-xl font-bold">Status do Pedido</h2>
              <p className="text-gray-500">Acompanhe o status atual do seu pedido</p>
            </div>
            <div className="relative">
              <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200" />
              <div className="space-y-8">
                <div className="relative pl-8">
                  <div className="absolute left-0 rounded-full p-1 bg-blue-500 text-white">
                    <ShoppingBag className="h-6 w-6" />
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <h4 className="font-medium">Pedido realizado</h4>
                      <CheckCircle className="h-4 w-4 text-green-500" />
                    </div>
                    <p className="text-sm text-gray-500">Seu pedido foi recebido e está sendo processado</p>
                    <p className="text-xs text-gray-500">15/04/2024 10:30</p>
                  </div>
                </div>

                <div className="relative pl-8">
                  <div className="absolute left-0 rounded-full p-1 bg-blue-500 text-white">
                    <CheckCircle className="h-6 w-6" />
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <h4 className="font-medium">Pagamento confirmado</h4>
                      <CheckCircle className="h-4 w-4 text-green-500" />
                    </div>
                    <p className="text-sm text-gray-500">Seu pagamento foi aprovado</p>
                    <p className="text-xs text-gray-500">15/04/2024 14:45</p>
                  </div>
                </div>

                <div className="relative pl-8">
                  <div className="absolute left-0 rounded-full p-1 bg-blue-500 text-white">
                    <Package className="h-6 w-6" />
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <h4 className="font-medium">Em preparação</h4>
                      <CheckCircle className="h-4 w-4 text-green-500" />
                    </div>
                    <p className="text-sm text-gray-500">Seu pedido está sendo preparado para envio</p>
                    <p className="text-xs text-gray-500">16/04/2024 09:15</p>
                  </div>
                </div>

                <div className="relative pl-8">
                  <div className="absolute left-0 rounded-full p-1 bg-blue-500 text-white">
                    <Truck className="h-6 w-6" />
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <h4 className="font-medium">Enviado</h4>
                      <CheckCircle className="h-4 w-4 text-green-500" />
                    </div>
                    <p className="text-sm text-gray-500">Seu pedido foi enviado</p>
                    <p className="text-xs text-gray-500">17/04/2024 11:30</p>
                  </div>
                </div>

                <div className="relative pl-8">
                  <div className="absolute left-0 rounded-full p-1 bg-gray-200 text-gray-500">
                    <CheckCircle className="h-6 w-6" />
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2">
                      <h4 className="font-medium">Entrega</h4>
                    </div>
                    <p className="text-sm text-gray-500">Previsão de entrega</p>
                    <p className="text-xs text-gray-500">20/04/2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="mb-4">
              <h2 className="text-xl font-bold">Detalhes do Produto</h2>
            </div>
            <div className="flex items-start gap-4">
              <div className="h-20 w-20 rounded-md bg-gray-100 flex items-center justify-center">
                <ShoppingBag className="h-10 w-10 text-gray-400" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium">Smartphone XYZ Pro</h3>
                <p className="text-sm text-gray-500">R$ 2.499,00 x 1</p>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium">Total</p>
                    <p className="font-bold">R$ 2.499,00</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium">Método de Pagamento</p>
                    <p className="text-sm">Cartão de crédito</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="mb-4">
              <h2 className="text-xl font-bold">Informações de Entrega</h2>
            </div>
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium flex items-center gap-2">
                  <MapPin className="h-4 w-4" />
                  Endereço de Entrega
                </h3>
                <div className="mt-2 text-sm">
                  <p>João da Silva</p>
                  <p>Rua das Flores, 123</p>
                  <p>Jardim Primavera</p>
                  <p>São Paulo - SP</p>
                  <p>CEP: 01234-567</p>
                </div>
              </div>
              <div className="border-t border-gray-200 my-2"></div>
              <div>
                <h3 className="text-sm font-medium flex items-center gap-2">
                  <Phone className="h-4 w-4" />
                  Contato
                </h3>
                <p className="mt-2 text-sm">(11) 98765-4321</p>
              </div>
              <div className="border-t border-gray-200 my-2"></div>
              <div>
                <h3 className="text-sm font-medium flex items-center gap-2">
                  <Truck className="h-4 w-4" />
                  Método de Entrega
                </h3>
                <p className="mt-2 text-sm">Entrega expressa</p>
                <p className="text-sm">Previsão: 20/04/2024</p>
              </div>
              <div className="border-t border-gray-200 my-2"></div>
              <div>
                <h3 className="text-sm font-medium flex items-center gap-2">
                  <Package className="h-4 w-4" />
                  Código de Rastreio
                </h3>
                <div className="mt-2 flex items-center gap-2">
                  <code className="bg-gray-100 rounded px-2 py-1 text-sm font-mono">
                    BR123456789
                  </code>
                  <button className="text-sm text-blue-500 hover:text-blue-700">
                    Copiar
                  </button>
                </div>
                <button className="mt-2 w-full border border-gray-300 rounded-md py-2 px-4 text-sm hover:bg-gray-50">
                  Rastrear Entrega
                </button>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="mb-4">
              <h2 className="text-xl font-bold">Precisa de Ajuda?</h2>
            </div>
            <div className="space-y-2">
              <button className="w-full border border-gray-300 rounded-md py-2 px-4 text-sm hover:bg-gray-50 flex items-center">
                <Mail className="h-4 w-4 mr-2" />
                Contatar Suporte
              </button>
              <button className="w-full border border-gray-300 rounded-md py-2 px-4 text-sm hover:bg-gray-50 flex items-center">
                <Package className="h-4 w-4 mr-2" />
                Relatar Problema
              </button>
              <button className="w-full border border-gray-300 rounded-md py-2 px-4 text-sm hover:bg-gray-50 flex items-center text-red-500">
                <XCircle className="h-4 w-4 mr-2" />
                Cancelar Pedido
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}